import {
	CART_TYPE,
	ICartItem,
	TCartValueAddedServices,
} from '@/services/cart/models/cart';
import { getColor } from '@/utils/theme/colors';
import { Box } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { useState } from 'react';
import CartVasCard from './CartVasCard';
import CartVasCustomizationPopup from './CartVasCustomizationPopup';

type TVasProps = {
	cartType: CART_TYPE;
	cartItems: ICartItem[];
	valueAddedServices?: TCartValueAddedServices[];
};

const Vas = (props: TVasProps) => {
	const [selectedVasToEdit, setSelectedVasToEdit] =
		useState<TCartValueAddedServices>();

	function onEditVasClicked(selectedVas: TCartValueAddedServices) {
		setSelectedVasToEdit(selectedVas);
	}

	function closeVasCustomizationPopup() {
		setSelectedVasToEdit(undefined);
	}

	return (
		<>
			<CartVasCustomizationPopup
				cartType={props.cartType}
				items={props.cartItems}
				selectedVasToEdit={selectedVasToEdit}
				setSelectedVasToEdit={setSelectedVasToEdit}
				onClose={closeVasCustomizationPopup}
			/>
			<Box>
				<LencoTypography variant='P_Medium'>
					Value added services
				</LencoTypography>
				<LencoTypography variant='Tiny_Regular' color={getColor('Gray -2')} mt='8px'>
					Add flexibility and security to these product with value added
					services{' '}
				</LencoTypography>
				{props.valueAddedServices?.map((vas) => (
					<CartVasCard
						key={vas.title}
						cartType={props.cartType}
						cartItems={props.cartItems}
						onEditClicked={onEditVasClicked}
						vasDetails={vas}
					/>
				))}
			</Box>
		</>
	);
};

export default Vas;
